import styled from 'styled-components';

export const ProjectIndicatorWrapper = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	width: 100%;
`;
